import { get } from '@aiptyg/api-client';
import type { TeamDetailResponseDTO } from '../types/team.types';

export function getTeamDetail(userId: number): Promise<TeamDetailResponseDTO> {
  return get<TeamDetailResponseDTO>(`/v1/admin/users/${userId}/team`);
}
